// Picks are rendered as a radio input plus a clickable label div per cell;
// this hides the raw radio and highlights whichever cell was picked.
export function initPickHighlighting() {
  document.querySelectorAll('input[type=radio]').forEach((radio) => {
    radio.style.display = 'none';
  });

  document.querySelectorAll('table div').forEach((div) => {
    div.addEventListener('click', () => {
      const radio = div.querySelector('input[type=radio]');
      if (radio) {
        radio.checked = true;
      }
      const row = div.closest('tr');
      if (row) {
        row
          .querySelectorAll('.checked')
          .forEach((el) => el.classList.remove('checked'));
      }
      div.classList.add('checked');
    });
  });
}
